module.exports = __webpack_public_path__ + "img/W-S31.265355b8.jpg";